import React, { useRef } from 'react';

/**
 * MagneticButton — element that gently follows the cursor within a small radius.
 * Wraps a child element (button/link) and applies transform on mousemove.
 */
const MagneticButton = ({ children, strength = 0.28, className = '' }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };

  const onLeave = () => {
    const el = ref.current;
    if (el) el.style.transform = 'translate(0,0)';
  };

  return (
    <span
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className={`inline-block magnetic ${className}`}
    >
      {children}
    </span>
  );
};

export default MagneticButton;
